import { createContext } from 'react';

const historicosDesviosCorrecoesContext = createContext();

export default historicosDesviosCorrecoesContext;
